import React, { Component } from 'react';
import FormInputs from '../../components/UI/FormInputs';
import TableGrid from '../../components/UI/TableGrid';
import { toQueryString } from '../../utils/commonUtils';
import withReduxState from '../../hoc/wReduxState';
import WithRoutify from '../../hoc/WithRoutify';
import PatientChartsService from '../../services/PatientChartsService';
import FileManagerService from '../../services/FileManagerService';
import EmrVisitsService from '../../services/EmrVisitsService';
import VisitsService from '../../services/VisitsService';
import EmployeeService from '../../services/EmployeeService';
import { capitalizeName } from '../../utils/commonUtils';
import WorkRestrictionsModal from '../EmrProviderContainer/Tabs/WorkRestrictionsModal';
import VaccineFilter from './VaccineFilter';
import ReactDOM from "react-dom";
import AddVaccine from '../EmployeeVisitContainer/AddVaccine';
import AddVisits from '../EmployeeVisitContainer/AddVisits';
import OrganizationService from '../../services/OrganizationService';
import GlobalSearch from '../../components/Layouts/NewAppLayout/GlobalSearch/GlobalSearch';
import PERMISSIONS from '../../utils/AclPermissions';
import Acl from '../../hoc/Acl';
import SendTaskModal from '../../components/Modal/SendTaskModal';

class WorkStatus extends Component {
  constructor(props) {
    super(props);
    // Initialize state or bind methods if needed
    const tableHeaders = [
      { label: '', key: 'isActive', type: 'checkBox', name: 'ALL', changeHandler: this.checkBoxchangeHandler },
      { label: 'Patient Name', key: 'patient_name' },
      { label: 'Provider', key: 'provider_name' },
      { label: 'Visit Date', key: 'visit_date' },
      { label: 'Visit Time', key: 'visit_time' },
      { label: 'Visit Category', key: 'visit_category' },
      { label: 'Action', key: 'action', type: 'Actions' },
      // Add more columns as needed
    ];
    this.state = {
      filters: {
        search_query: ''
      },
      tableRecords: {
        tableHeaders: tableHeaders,
        tableRows: {
          data: [],
          status: 1000,
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: 'date',
          sort_order: 'desc',
          search: {},
        }
      },
      activeEditId: null,
      activeEditData: null,
      isModelOpen: false,
      isAddVisitModelOpen: false,
      visitsAutoFillData: {},
      filterOpen: false,
      isWorkStatusModalOpen: false,
      selectedVisitId: null,
      workStatusFormData: null,
      visitDetails: null,
      employeeDetails: null,
    }
  }

  componentDidMount() {
    // Check for query parameters to auto-open work status modal
    const { location } = this.props;
    const queryParams = new URLSearchParams(location.search);
    const visitId = queryParams.get('visitId');
    
    if (visitId) {
      // Fetch the work status data and open modal
      this.fetchWorkStatusAndOpenModal(visitId);
    }
    
    this.fetchWorkStatusResult();
  }

  fetchWorkStatusAndOpenModal = async (visitId) => {
    const { Loader, Toast } = this.props;
    try {
      if (Loader) Loader(true);
      
      // Fetch work status form data, visit details, and employee details in parallel (same as handleEdit)
      const [formData, visitData] = await Promise.all([
        EmrVisitsService.getWorkStatusFormById(visitId),
        VisitsService.getVisits(visitId)
      ]);
      
      if (formData && !formData.error) {
        // Get employee ID from form data
        const employeeId = formData.employee_id;
        
        // Fetch employee details if we have employee ID
        let employeeDetailsData = null;
        if (employeeId) {
          try {
            employeeDetailsData = await EmployeeService.getEmployee(employeeId);
          } catch (err) {
            console.error("Error fetching employee details:", err);
            // Continue even if employee fetch fails
          }
        }
        
        // Format visit details similar to how handleEdit does it
        const visitDetailsFormatted = visitData && visitData[0] ? { ...visitData[0], ...visitData } : null;
        
        this.setState({
          workStatusFormData: formData,
          selectedVisitId: visitId,
          visitDetails: visitDetailsFormatted,
          employeeDetails: employeeDetailsData || formData.employee,
          isWorkStatusModalOpen: true,
        });
      } else {
        if (Toast) {
          Toast.error("Failed to fetch work status form");
        }
      }
    } catch (error) {
      console.error('Error fetching work status data:', error);
      if (Toast) {
        Toast.error("Failed to fetch work status form");
      }
    } finally {
      if (Loader) Loader(false);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.globalFilter.Vaccine!==this.props?.globalFilter?.Vaccine) {
      this.fetchWorkStatusResult();
    }
  }

  handleEvent = () => {
    // Handler for events (e.g., button click)
  };
  addFormHandler = () => {
    this.setState({ isModelOpen: !this.state.isModelOpen })
  }
  addVisitToogleHandler = (visitData = false) => {
    let updatedState = { ...this.state };
    
    // If visitData is provided (visit object), pre-fill patient data
    if (visitData && typeof visitData === 'object' && (visitData.employee_id || visitData.employee?.employee_id)) {
      updatedState = {
        ...updatedState,
        ["visitsAutoFillData"]: {
          company_id: visitData.company_id || '',
          employee_id: visitData.employee_id || visitData.employee?.employee_id || '',
          organization_id: OrganizationService.getOrgId(),
        },
        ["isAddVisitModelOpen"]: !this.state.isAddVisitModelOpen,
      };
    } else if (visitData === true) {
      // Handle boolean flag for empty auto fill data (backward compatibility)
      updatedState = {
        ...updatedState,
        ["visitsAutoFillData"]: {},
        ["isAddVisitModelOpen"]: !this.state.isAddVisitModelOpen,
      };
    } else {
      // Default: just toggle modal without pre-filling
      updatedState = {
        ...updatedState,
        ["isAddVisitModelOpen"]: !this.state.isAddVisitModelOpen,
      };
    }
    
    this.setState(updatedState);
  }

  onChangeFiltersHandler = (key, val) => {
    const { filters } = this.state;
    this.setState({
      filters: {
        ...filters,
        [key]: val
      }
    })
  }
  render() {
    const { tableRecords, filters, isModelOpen, isAddVisitModelOpen, visitsAutoFillData, activeEditId, activeEditData } = this.state;
    const globalSearchFilter = [
      "/visits",
      "/appointments",
      "/white-board",
      "/labs",
      "/result/vaccine",
      "/result/physical-drug-screens",
      "/result/workstatus",
      "/employee",
    ];
    const { profile, location,isNewUI} = this.props;
    const { pathname } = location;
    return (
      <>
        {isModelOpen ? (
          <AddVaccine
            isOpen={this.state.isModelOpen}
            activeEditId={activeEditId}
            mapping_id={activeEditData.visit_mapping_id}
            visitId={activeEditData.visit_id}
            activeEditData={activeEditData}
            fetchRecords={this.fetchWorkStatusResult}
            modalToogleHandler={this.addFormHandler}
            fromChart={false}
          />
        ) : (
          <></>
        )}
       
        <div className="sh_cardBox">
           <div className="sh_cardHeader pb-0">
              <div class="d-flex flex-column">
              <div class="d-flex position-relative">
                  <h2 class="h2-strong position-relative">Work Status List</h2>
                    {/* {isNewUI &&
                      profile &&
                      profile.is_multiple_organization === false &&
                      profile.employee_login === false &&
                      globalSearchFilter.some((path) => pathname.startsWith(path)) && (
                      <GlobalSearch
                          activeMenu={"WorkStatus"}
                          pathname={pathname}
                      />
                )} */}
                </div>
              </div>
          </div>

              <div className="sh_cardHeader sh_cardbglight">
                <div className="form-group d-flex mb-0 justify-content-end align-items-center">
                  {/* Bulk Action Button - Show when items are selected */}
                  {this.anyCheckboxSelected() && (
                    <Acl acl={PERMISSIONS.WORK_STATUS.EDIT}>
                      <div className="dropdown">
                        <button
                          className="btn btn-primary dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Send ({this.getSelectedIds().length})
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end">
                          <li>
                            <button
                              className="dropdown-item"
                              type="button"
                              onClick={this.bulkSendSmsEmailHandler}
                            >
                              Send to Patient
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              type="button"
                              onClick={this.bulkSendEmailToEmployerHandler}
                            >
                              Send to Employer
                            </button>
                          </li>
                        </ul>
                      </div>
                    </Acl>
                  )}
                  {/* <h6 class="text-xl f-500 mb-0 "> Vaccine Result</h6> */}
                  <div className="d-flex">
                    <div className="form-group-fields row mr-2">
                      <div className="col-12 px-1 d-flex">
                        <div className="input-group input-group-joined input-group-solid">
                        </div>
                        <div className="col-12">
                            <div className="btn-group ">
                            <div className="input-group input-group-joined input-group-solid">
                              <FormInputs
                                placeholder="work status"
                                value={filters["search_query"]}
                                changeHandler={(val) =>
                                  this.onChangeFiltersHandler("search_query", val)
                                }
                                className="form-control"
                              />
                            </div>
                            </div>
                          <div className="btn-group pl-2 pt-1">
                            {/* <Buttons
                              clickHandler={this.filterOnClick}
                              className="btn btn-outline-secondary mr-2"
                              acl={"any"}
                              label={"Search by "}
                              iconType={"Filter"}
                            ></Buttons> */}

                            <button
                              className="btn btn-primary"
                              onClick={() => this.submitFiltersHandler()}
                            >
                              Search
                            </button>
                            <button
                              className="btn btn-outline-secondary"
                              onClick={() => this.clearFiltersHandler()}
                            >
                              Clear
                            </button>

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
          
          <div className="sh_cardBody p-0 sh_cardbglight">
            <TableGrid
              hasPagination={true}
              fetchTableRecords={(filters) => this.fetchWorkStatusResult(filters)}
              {...tableRecords}
            />
          </div>
        </div>
        {this.state.filterOpen ? (
          <>
            {ReactDOM.createPortal(
              // <VaccineFilter
              //   onChangeHandler={this.onChangeFiltersHandler}
              //   filterData={this.state.filters}
              //   closeHandler={this.filterCloseHandler}
              //   submitHandler={this.submitFiltersHandler}
              // />,
              document.getElementById("sh_mainportal_view") // Render the component into the portal container
            )}
          </>
        ) : (
          ""
        )}
        
        {this.state.isWorkStatusModalOpen && (
          <WorkRestrictionsModal
            isOpen={this.state.isWorkStatusModalOpen}
            onClose={this.handleModalClose}
            visit_id={this.state.selectedVisitId}
            employeeId={this.state.workStatusFormData?.employee_id || this.state.employeeDetails?.employee_id}
            employeeDetails={this.state.employeeDetails || this.state.workStatusFormData?.employee}
            fetchEmployeeDetails={this.fetchEmployeeDetails}
            visitDetails={this.state.visitDetails}
            Loader={this.props.Loader}
            workStatusFormData={this.state.workStatusFormData}
            Toast={this.props.Toast}
          />
        )}
        {this.state.sendTaskModalOpen && (
          <SendTaskModal
            isOpen={this.state.sendTaskModalOpen}
            modalToogleHandler={() => this.setState({ sendTaskModalOpen: false, selectedNavigationLink: null })}
            Toast={this.props.Toast}
            Loader={this.props.Loader}
            navigationLink={this.state.selectedNavigationLink}
          />
        )}
      </>
    );
  }

  submitFiltersHandler = async () => {
    const { filters, tableRecords } = this.state;
    const { pagination } = tableRecords;
    const queryfilters = {
      ...pagination,
      search: filters,
    }
    this.fetchWorkStatusResult(queryfilters);
  }
  clearFiltersHandler = () => {
    this.setState({
      filters: {}
    }, this.submitFiltersHandler);
  }
  fetchWorkStatusResult = async (query = {}) => {
    const { tableRecords } = this.state;
    const { profile } = this.props;
    let queryString = toQueryString({ ...tableRecords.pagination, ...query });
    const globalFilter=this.props?.globalFilter?.Vaccine || {};
    if (this.props.isFromEmployeeHistory && this.props.employee_id) {
      queryString.employee_id = this.props.employee_id;
    }
    queryString = {...queryString,...globalFilter}
    try {
      this.props.Loader(true);
      const Result = await PatientChartsService.getWorkStatusResult(null, queryString);
      let tableData = [];
      console.log("Work Status Result:", Result);
      
      Result.data.data.forEach((item, index) => {
        // Get patient name from employee - backend should provide employee_name or employee relationship
        let patientName = '--';
        
        // First try employee_name (set by backend transform)
        if (item.employee_name && typeof item.employee_name === 'string' && item.employee_name.trim() !== '') {
          patientName = item.employee_name.trim();
        } 
        // Fallback to employee relationship
        else if (item.employee) {
          const firstName = item.employee.first_name || '';
          const lastName = item.employee.last_name || '';
          const fullName = `${firstName} ${lastName}`.trim();
          if (fullName !== '') {
            patientName = fullName;
          }
        }
        
        // Debug log if name is still '--'
        if (patientName === '--') {
          console.warn('No patient name found for item:', item);
        }
        
        // Get visit information
        const visitDate = item.visit?.visit_date || '--';
        const visitTime = item.visit?.visit_time || '--';
        const visitCategory = item.visit?.visit_category ? capitalizeName(item.visit.visit_category) : '--';
        
        // Get provider name
        const providerName = item.visit?.primary_provider 
          ? `${item.visit.primary_provider.first_name || ''} ${item.visit.primary_provider.last_name || ''}`.trim() || '--'
          : '--';
       
        tableData = [
          ...tableData,
          {
            labsIndex: index,
            isHeading: false,
            rowId: item.work_status_form_id,
            visit_id: item.visit_id, // Store visit_id for bulk operations
            employee_id: item.employee_id || item?.employee?.employee_id, // Store employee_id
            employee_email: item?.employee?.email, // Store employee email
            employee_phone: item?.employee?.phone, // Store employee phone
            employer_email: item?.employer?.employer_email || item?.visit?.company?.general_email, // Store employer email (company.general_email)
            email_sent: item.email_sent || false, // Store email_sent flag
            sms_sent: item.sms_sent || false, // Store sms_sent flag
            data: {
              isActive: false,
              patient_name: patientName,
              provider_name: providerName,
              visit_date: visitDate,
              visit_time: visitTime,
              visit_category: visitCategory,
              action: [
                {
                  className: 'btn btn-icon btn-transparent-dark',
                  iconType: 'Search',
                  title: 'Edit',
                  acl: PERMISSIONS.WORK_STATUS.EDIT,
                  clickHandler: () => this.handleEdit(item),
                },
                {
                  className: 'btn btn-icon btn-transparent-dark',
                  iconType: 'Print',
                  title: 'Print',
                  acl: PERMISSIONS.WORK_STATUS.PRINT,
                  accessType:"Hide",
                  clickHandler: () => this.handlePrint(item),
                },
                {
                  className: 'btn btn-icon btn-transparent-dark',
                  iconType: 'Email',
                  iconSize: 18,
                  iconColor: item.email_sent ? '#28a745' : null,
                  title: 'Send Email',
                  acl: PERMISSIONS.WORK_STATUS.SEND_EMAIL,
                  accessType:"Hide",
                  iconDropDownList: [
                    { label: 'Send to Patient', clickHandler: () => this.handleMail(item, 'patient') },
                    { label: 'Send to Employer', clickHandler: () => this.handleMail(item, 'employer') },
                  ],
                },
                {
                  className: 'btn btn-icon btn-transparent-dark',
                  iconType: 'Phone',
                  iconSize: 18,
                  iconColor: item.sms_sent ? '#28a745' : null,
                  title: 'Send SMS',
                  acl: PERMISSIONS.WORK_STATUS.SEND_SMS,
                  clickHandler: () => this.handleSms(item),
                  accessType:"Hide",
                },
                {
                  className: 'btn btn-icon btn-transparent-dark',
                  iconType: 'ChatSquareTextFill',
                  acl: PERMISSIONS.WORK_STATUS.SEND_MESSAGE,
                  accessType:"Hide",
                  title: 'Send Message',
                  clickHandler: () => {
                    const workStatusDetailUrl = `/result/workstatus?visitId=${item.visit_id}`;
                    this.sendTaskModalHandler(workStatusDetailUrl);
                  }
                },
              // {
              //   className: 'btn btn-icon btn-transparent-dark',
              //   iconType: 'Remove',
              //   title: 'Delete',
              //   acl: PERMISSIONS.WORK_STATUS.DELETE,
              //   clickHandler: (rowId, data) => this.deleteHandler(item.work_status_form_id, item),
              // },
              ]
            }
          }
        ]
      });
      this.setState((prevState) => ({
        tableRecords: {
          ...prevState.tableRecords,
          tableHeaders: prevState.tableRecords.tableHeaders,
          tableRows: {
            status: 200,
            type: "default",
            data: tableData,
          },
          pagination: {
            ...prevState.tableRecords.pagination,
            ...query,
            totalRecords: Result.data.total
          },
        },
      }));
      this.props.Loader();
    } catch (e) {
      this.setState({
        tableRecords: {
          ...tableRecords,
          tableRows: {
            ...tableRecords.tableRows,
            status: 200
          }
        }
      });
      this.props.Loader();
    }
  }
  // deleteHandler = async (Id, item) => {
  //   const { Loader, Toast } = this.props;
  //   Loader(true);
  //   try {
  //     const response = await PatientChartsService.deleteWorkStatus(null, Id);
  //     if (response) {
  //       Toast.success("Work Status deleted successfully");
  //       // Refresh the table data after successful deletion
  //       this.fetchWorkStatusResult();
  //     } else {
  //       Toast.error("Failed to delete Work Status");
  //     }
  //   } catch (error) {
  //     console.error("Error deleting Work Status:", error);
  //     Toast.error("Error while deleting Work Status. Please try again.");
  //   } finally {
  //     Loader(false);
  //   }
  // }
  editHandler = (rowId, data) => {
    this.setState({
      activeEditId: rowId,
      activeEditData: data
    }, this.addFormHandler());
  }

  handleEdit = async (item) => {
    const { Loader, Toast } = this.props;
    try {
      if (Loader) Loader(true);
      
      // Fetch work status form data, visit details, and employee details in parallel
      const [formData, visitData] = await Promise.all([
        EmrVisitsService.getWorkStatusFormById(item.visit_id),
        VisitsService.getVisits(item.visit_id)
      ]);
      
      if (formData && !formData.error) {
        // Get employee ID from form data or item
        const employeeId = formData.employee_id || item.employee_id || item?.employee?.employee_id;
        
        // Fetch employee details if we have employee ID
        let employeeDetailsData = null;
        if (employeeId) {
          try {
            employeeDetailsData = await EmployeeService.getEmployee(employeeId);
          } catch (err) {
            console.error("Error fetching employee details:", err);
            // Continue even if employee fetch fails
          }
        }
        
        // Format visit details similar to how WorkStatusPage does it
        const visitDetailsFormatted = visitData && visitData[0] ? { ...visitData[0], ...visitData } : null;
        
        this.setState({
          workStatusFormData: formData,
          selectedVisitId: item.visit_id,
          visitDetails: visitDetailsFormatted,
          employeeDetails: employeeDetailsData || formData.employee || item.employee,
          isWorkStatusModalOpen: true,
        });
      } else {
        if (Toast) {
          Toast.error("Failed to fetch work status form");
        }
      }
    } catch (error) {
      console.error("Error fetching work status form:", error);
      if (Toast) {
        Toast.error("Failed to fetch work status form");
      }
    } finally {
      if (Loader) Loader(false);
    }
  }

  fetchEmployeeDetails = async (employeeId) => {
    const { Loader } = this.props;
    try {
      if (employeeId) {
        if (Loader) Loader(true);
        const data = await EmployeeService.getEmployee(employeeId);
        this.setState({ employeeDetails: data });
        if (Loader) Loader(false);
      }
    } catch (error) {
      if (Loader) Loader(false);
      console.error("Error fetching employee details:", error);
    }
  }

  handleModalClose = () => {
    this.setState({
      isWorkStatusModalOpen: false,
      selectedVisitId: null,
      workStatusFormData: null,
      visitDetails: null,
      employeeDetails: null,
    });
    // Refresh the table data after closing modal
    this.fetchWorkStatusResult();
  }

  sendTaskModalHandler = (navigationLink = null) => {
    this.setState({
      sendTaskModalOpen: true,
      selectedNavigationLink: navigationLink,
    });
  }

  handlePrint = async (item) => {
    const { Loader, Toast } = this.props;
    try {
      if (Loader) Loader(true);
      
      const response = await EmrVisitsService.printWorkStatusForm(item.visit_id);
      console.log("Print response:", response);
      
      // Handle different response structures
      const base64Data = typeof response === 'string' ? response : (response?.data || response);
      
      if (base64Data && typeof base64Data === 'string' && base64Data.length > 0) {
        const pdfData = {
          file_content: base64Data,
          original_name: `snap work status report`,
          mime_type: 'application/pdf'
        };
        FileManagerService.printPdf(pdfData);
      } else {
        console.error("Invalid PDF data received:", base64Data);
        if (Toast) {
          Toast.error("Failed to generate work status form PDF");
        }
      }
    } catch (error) {
      console.error("Error printing work status form:", error);
      if (Toast) {
        Toast.error("Failed to print work status form");
      }
    } finally {
      if (Loader) Loader(false);
    }
  }

  handleMail = async (item, recipientType = 'patient') => {
    const { Loader, Toast } = this.props;
    try {
      if (Loader) Loader(true);

      // Support both raw API item (employee.email, employer.employer_email) and table row (employee_email, employer_email)
      const employeeEmail = item?.employee?.email ?? item?.employee_email;
      const employerEmail = item?.employer?.employer_email ?? item?.visit?.company?.general_email ?? item?.employer_email;

      const email = recipientType === 'employer' ? employerEmail : employeeEmail;
      const recipientLabel = recipientType === 'employer' ? 'employer' : 'patient';

      if (!email) {
        if (Toast) {
          Toast.error(`${recipientType === 'employer' ? 'Employer' : 'Patient'} email not found. Cannot send email.`);
        }
        if (Loader) Loader(false);
        return;
      }

      const response = await EmrVisitsService.sendWorkStatusFormEmail(item.visit_id, email, recipientType);

      if (response && (response.code === 200 || response.code === 201)) {
        if (Toast) {
          Toast.success(`Work status report sent successfully to ${recipientLabel} (${email})`);
        }

        // Update email_sent flag by calling save API
        const employeeIdToSave = item.employee_id || item?.employee?.employee_id;
        if (employeeIdToSave) {
          const savePayload = {
            employee_id: employeeIdToSave,
            email_sent: true,
            sms_sent: item.sms_sent || false,
          };

          await EmrVisitsService.saveWorkStatusForm(item.visit_id, savePayload);

          this.fetchWorkStatusResult();
        }
      } else {
        if (Toast) {
          Toast.error(response?.data?.error || response?.message || "Failed to send work status report email");
        }
      }
    } catch (error) {
      console.error("Error sending work status form email:", error);
      if (Toast) {
        Toast.error("Failed to send work status report email");
      }
    } finally {
      if (Loader) Loader(false);
    }
  }

  handleSms = async (item) => {
    const { Loader, Toast } = this.props;
    try {
      if (Loader) Loader(true);

      // Get employee phone from item
      const employeePhone = item?.employee?.phone;
      
      if (!employeePhone) {
        if (Toast) {
          Toast.error("Employee phone number not found. Cannot send SMS.");
        }
        return;
      }

      const response = await EmrVisitsService.sendWorkStatusFormSMS(item.visit_id, employeePhone);
      
      if (response && (response.code === 200 || response.code === 201)) {
        if (Toast) {
          Toast.success("Work status report SMS sent successfully to " + employeePhone);
        }
        
        // Update sms_sent flag by calling save API
        const employeeIdToSave = item.employee_id || item?.employee?.employee_id;
        if (employeeIdToSave) {
          const savePayload = {
            employee_id: employeeIdToSave,
            email_sent: item.email_sent || false,
            sms_sent: true,
          };
          
          await EmrVisitsService.saveWorkStatusForm(item.visit_id, savePayload);
          
          // Refresh the list after saving
          this.fetchWorkStatusResult();
        }
      } else {
        if (Toast) {
          Toast.error(response?.data?.error || response?.message || "Failed to send work status report SMS");
        }
      }
    } catch (error) {
      console.error("Error sending work status form SMS:", error);
      if (Toast) {
        Toast.error("Failed to send work status report SMS");
      }
    } finally {
      if (Loader) Loader(false);
    }
  }
  onChangeFiltersHandler = (key, val) => {
    const { filters } = this.state;
    this.setState({
      filters: {
        ...filters,
        [key]: val
      }
    });
  }
  printLabel = async (id, pdfname = 'WorkStatusResult') => {
    try{
    const response = await PatientChartsService.getWorkStatusPDF(null, id);
    const pdfData = {
      file_content: response,
      original_name: `${pdfname}`,
      mime_type: 'application/pdf'
    }
    FileManagerService.printPdf(pdfData);
  }catch(err){
      
  }
  }
  sendsmsemailHandler = async (id) => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const response = await PatientChartsService.sendWorkStatusSMSEmailResult(null, id);
      if (response) {
        Toast.success("SMS & Email sent successfully");
      } else {
        Toast.error("Failed to send SMS & Email");
      }
    } catch (error) {
      console.error("Error sending SMS & Email:", error);
      Toast.error("Error while sending SMS & Email. Please try again.");
    } finally {
      Loader(false);
    }
  }
  
  filterOnClick = () => {
    this.setState({
      filterOpen: !this.state.filterOpen,
    }, () => {
      if (document.body.classList.contains('filterOpened')) {
        document.body.classList.remove('filterOpened');
        // menuToggleElement.removeClass('active');
      } else {
        document.body.classList.add('filterOpened');
      }
    });
  };
  filterCloseHandler = (isClear = true) => {
    if (isClear) {
      this.clearFiltersHandler();
    }
    else {
      this.setState({
        filterOpen: false,
      }, () => {
        if (document.body.classList.contains('filterOpened')) {
          document.body.classList.remove('filterOpened');
          // menuToggleElement.removeClass('active');
        } else {
          document.body.classList.add('filterOpened');
        }
      });
    }
  };
  checkBoxchangeHandler = (value, { e }, rowId = '') => {
    if (!rowId) {
      rowId = e.target.id;
    }
    const { tableRows } = this.state.tableRecords;
    let updatedData;
    
    // Handle "Select All" functionality
    if (rowId === 'ALL') {
      updatedData = tableRows.data.map((item) => {
        item.data.isActive = value;
        return item;
      });
    } else {
      // Handle individual row selection
      updatedData = tableRows.data.map((item) => {
        if (item.rowId === rowId) {
          item.data.isActive = value;
        }
        return item;
      });
    }
    
    // Update header checkbox state to reflect if all items are selected
    const allSelected = updatedData.every(item => item.data.isActive === true || item.data.isActive === 1);
    const allCheckbox = document.getElementById('ALL');
    if (allCheckbox) {
      allCheckbox.checked = allSelected;
    }

    this.setState((prevState) => ({
      tableRecords: {
        ...prevState.tableRecords,
        tableRows: {
          data: updatedData,
        },
      },
    }));
  };

  // Get selected work status IDs from checkboxes
  getSelectedIds = () => {
    const { tableRows } = this.state.tableRecords;
    if (!tableRows || !Array.isArray(tableRows.data)) {
      return [];
    }
    return tableRows.data
      .filter(item => item.data?.isActive === true || item.data?.isActive === 1)
      .map(item => item.rowId);
  };

  // Check if any checkbox is selected
  anyCheckboxSelected = () => {
    return this.getSelectedIds().length > 0;
  };

  // Bulk send SMS & Email handler
  bulkSendSmsEmailHandler = async () => {
    const { Loader, Toast } = this.props;
    const selectedIds = this.getSelectedIds();
    
    if (selectedIds.length === 0) {
      Toast.error("Please select at least one work status to send SMS & Email");
      return;
    }

    Loader(true);
    
    // Get the table data to find the selected items
    const { tableRows } = this.state.tableRecords;
    const selectedItems = tableRows.data.filter(item => 
      selectedIds.includes(item.rowId)
    );

    let successCount = 0;
    let failCount = 0;
    const errors = [];

    // Process each selected item
    for (const tableItem of selectedItems) {
      try {
        const visitId = tableItem.visit_id;
        const employeeEmail = tableItem.employee_email;
        const employeePhone = tableItem.employee_phone;
        const employerEmail = tableItem.employer_email;
        const employeeId = tableItem.employee_id;

        if (!visitId) {
          failCount++;
          errors.push(`Work status ${tableItem.rowId}: Missing visit ID`);
          continue;
        }

        let emailSent = false;
        let smsSent = false;

        // Send email if available
        if (employeeEmail) {
          try {
            const emailResponse = await EmrVisitsService.sendWorkStatusFormEmail(visitId, employeeEmail);
            if (emailResponse && (emailResponse.code === 200 || emailResponse.code === 201)) {
              emailSent = true;
            }
          } catch (err) {
            console.error(`Error sending email for visit ${visitId}:`, err);
          }
        }

        // Send SMS if available
        if (employeePhone) {
          try {
            const smsResponse = await EmrVisitsService.sendWorkStatusFormSMS(visitId, employeePhone);
            if (smsResponse && (smsResponse.code === 200 || smsResponse.code === 201)) {
              smsSent = true;
            }
          } catch (err) {
            console.error(`Error sending SMS for visit ${visitId}:`, err);
          }
        }

        // Update flags if at least one was sent successfully
        if ((emailSent || smsSent) && employeeId) {
          try {
            const savePayload = {
              employee_id: employeeId,
              email_sent: emailSent || tableItem.email_sent || false,
              sms_sent: smsSent || tableItem.sms_sent || false,
            };
            await EmrVisitsService.saveWorkStatusForm(visitId, savePayload);
          } catch (err) {
            console.error(`Error saving flags for visit ${visitId}:`, err);
          }
        }

        if (emailSent || smsSent) {
          successCount++;
        } else {
          failCount++;
          const patientName = tableItem.data?.patient_name || 'Unknown';
          if (!employeeEmail && !employeePhone) {
            errors.push(`${patientName}: No email or phone available`);
          } else if (!employeeEmail) {
            errors.push(`${patientName}: Email not sent (no email address)`);
          } else if (!employeePhone) {
            errors.push(`${patientName}: SMS not sent (no phone number)`);
          } else {
            errors.push(`${patientName}: Failed to send`);
          }
        }
      } catch (error) {
        console.error(`Error processing work status ${tableItem.rowId}:`, error);
        failCount++;
        const patientName = tableItem.data?.patient_name || 'Unknown';
        errors.push(`${patientName}: ${error.message || 'Unknown error'}`);
      }
    }

    // Show results
    if (successCount > 0 && failCount === 0) {
      Toast.success(`SMS & Email sent successfully to ${successCount} work status(es)`);
    } else if (successCount > 0 && failCount > 0) {
      Toast.warning(`Sent to ${successCount} work status(es), ${failCount} failed. ${errors.slice(0, 3).join('; ')}${errors.length > 3 ? '...' : ''}`);
    } else {
      Toast.error(`Failed to send SMS & Email. ${errors.slice(0, 3).join('; ')}${errors.length > 3 ? '...' : ''}`);
    }

    // Refresh the list
    this.fetchWorkStatusResult();
    Loader(false);
  };

  // Bulk send one email per employer with all selected work status PDFs attached
  bulkSendEmailToEmployerHandler = async () => {
    const { Loader, Toast } = this.props;
    const selectedIds = this.getSelectedIds();

    if (selectedIds.length === 0) {
      Toast.error("Please select at least one work status to send email to employer");
      return;
    }

    Loader(true);

    const { tableRows } = this.state.tableRecords;
    const selectedItems = tableRows.data.filter(item =>
      selectedIds.includes(item.rowId)
    );

    // Group by employer_email so we send one email per employer with all their visit_ids
    const byEmployer = {};
    const noEmployerEmail = [];

    for (const tableItem of selectedItems) {
      const visitId = tableItem.visit_id;
      const employerEmail = tableItem.employer_email;

      if (!visitId) continue;

      if (!employerEmail) {
        noEmployerEmail.push(tableItem.data?.patient_name || 'Unknown');
        continue;
      }

      if (!byEmployer[employerEmail]) {
        byEmployer[employerEmail] = [];
      }
      byEmployer[employerEmail].push(visitId);
    }

    if (noEmployerEmail.length === selectedItems.length) {
      Toast.error("No employer email available for selected items.");
      Loader(false);
      return;
    }

    let successCount = 0;
    let failCount = 0;
    const errors = [];

    for (const [email, visitIds] of Object.entries(byEmployer)) {
      try {
        const response = await PatientChartsService.sendBulkWorkStatusFormEmailToEmployer({
          email,
          visit_ids: visitIds,
        });

        if (response && (response.code === 200 || response.code === 201)) {
          successCount++;
        } else {
          failCount++;
          errors.push(`${email}: ${response?.data?.error || response?.message || 'Failed to send'}`);
        }
      } catch (err) {
        console.error(`Error sending bulk email to employer ${email}:`, err);
        failCount++;
        errors.push(`${email}: ${err.message || 'Failed to send'}`);
      }
    }

    if (successCount > 0 && failCount === 0) {
      Toast.success(`One email with all selected reports sent successfully to ${successCount} employer(s)`);
    } else if (successCount > 0 && failCount > 0) {
      Toast.warning(`Sent to ${successCount} employer(s), ${failCount} failed. ${errors.slice(0, 3).join('; ')}${errors.length > 3 ? '...' : ''}`);
    } else {
      Toast.error(`Failed to send email to employers. ${errors.slice(0, 3).join('; ')}${errors.length > 3 ? '...' : ''}`);
    }

    if (noEmployerEmail.length > 0) {
      Toast.warning(`${noEmployerEmail.length} selected row(s) had no employer email and were skipped.`);
    }

    this.fetchWorkStatusResult();
    Loader(false);
  };

}

export default withReduxState(WithRoutify(WorkStatus));